import { Stack, Typography, Box, CircularProgress, Alert, Button, Grid } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { SetupForm } from './SetupForm'

import { Modal, ModalHeader, ModalTitle, ModalContent } from '@/components/tailwind-ui'

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)

export default function AddCreditCardModal({
  open,
  onClose,
  clientSecret,
  onCancelAddCard,
  onSetupError,
  onSetupSuccess,
  isBillingMode,
}) {
  return (
    <Modal open={open} size="md" onClose={onClose}>
      <ModalHeader>
        <ModalTitle>Add New Payment Method</ModalTitle>
      </ModalHeader>
      <ModalContent>
        {isBillingMode ? (
          // Billing Mode: Use SetupIntent (always saves)
          clientSecret ? (
            <Elements
              options={{
                clientSecret,
                appearance: {
                  theme: 'stripe',
                },
              }}
              stripe={stripePromise}
            >
              <SetupForm
                hideCheckbox // Hide save card checkbox in billing mode
                clientSecret={clientSecret}
                onCancel={onCancelAddCard}
                onError={onSetupError}
                onSuccess={setupIntent => onSetupSuccess(setupIntent, true)} // Always save in billing
              />
            </Elements>
          ) : (
            <Stack alignItems="center" gap="16px" height="100%" justifyContent="center" minHeight="200px">
              <Typography>Loading...</Typography>
              <CircularProgress size={24} />
            </Stack>
          )
        ) : (
          // Purchase Mode: Manual creation (optional save)
          <Elements
            options={{
              mode: 'setup',
              currency: 'usd',
              paymentMethodCreation: 'manual',
              paymentMethodTypes: ['card'],
              appearance: {
                theme: 'stripe',
              },
            }}
            stripe={stripePromise}
          >
            <SetupForm
              onCancel={onCancelAddCard}
              onError={onSetupError}
              onSuccess={(paymentMethod, saveCard) => onSetupSuccess(paymentMethod, saveCard)}
            />
          </Elements>
        )}
      </ModalContent>
    </Modal>
  )
}
